import { render, staticRenderFns } from "./relsugestaotrimestral.vue?vue&type=template&id=3be20b54&"
import script from "./relsugestaotrimestral.vue?vue&type=script&lang=js&"
export * from "./relsugestaotrimestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports